import { render, staticRenderFns } from "./Search.component.vue?vue&type=template&id=67ac6cbc&scoped=true"
import script from "./Search.component.vue?vue&type=script&lang=js"
export * from "./Search.component.vue?vue&type=script&lang=js"
import style0 from "./Search.component.vue?vue&type=style&index=0&id=67ac6cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac6cbc",
  null
  
)

export default component.exports